import React, { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import { withStyles } from "@material-ui/core";
import Table from "../../../../../../../components/Table/Table";
import Scroll from "../../../../../../../components/InfiniteScroll/Scroll";
import InputMaskCurrency from "../../../../../../../components/Input/InputMaskCurrency";
import { TextFieldSearch } from "../../../../../../../components/TextField";
import { findAllProcedimentos, sujeitoAtencaoAutorizadoAgendarDetalhado } from "../../../../../../../services/OrcamentoService";
import TrashIcon from "../../../../../../../components/Icon/Trash";
import string from "../../../../../../../utils/string";
import { applyCurrencyMask } from "../../../../../../../utils/CurrencyMask";
import classNames from "classnames";
import { UNIDADE_LOGADA_KEY } from "../../../../../../../services/storage";
import { findConfiguracaoUnidade } from "../../../../../../../services/ConfiguracoesUnidadeService";

const inputStyle = {
  textAlign: "center",
  backgroundColor: "#F2F2F2",
  padding: "4px 8px",
  borderRadius: "8px",
  width: "100%",
  maxWidth: "100px",
  height: "32px",
};

const tableStatusStyle = {
  padding: "4px 16px",
};

const getColumns = ({
  handleChangeValorProcedimento,
  handleRemoveProcedimento,
}) => [
  {
    Header: "Procedimento",
    style: tableStatusStyle,
    getValue: (item) => item.procedimento.nome,
  },
  {
    Header: "Valor",
    style: tableStatusStyle,
    getValue: (item, index) => {
      return (
        <InputMaskCurrency
          id={`prt-pro-inp-vlr-${index}`}
          value={item?.valorUnitario || ""}
          onChange={(e) => handleChangeValorProcedimento(e.target.value, index)}
          style={inputStyle}
        />
      );
    },
  },
  {
    Header: "",
    style: tableStatusStyle,
    getValue: (item, index) => (
      <TrashIcon
        id={`prt-pro-btn-rmv-${index}`}
        size="20"
        onClick={() => handleRemoveProcedimento(item, index)}
      />
    ),
  },
];

const Procedimentos = observer(
  ({
    classes,
    handleFieldModal,
    orcamentoProcedimentos,
    orcamentoStore,
    orcamento,
    sujeitoAtencaoSelected,
  }) => {
    const [utilizaFiltroPorConvenio,setUtilizaFiltroPorConvenio]=useState(false)
    const { convenio, tipoPagamento, id } = orcamento || {};
    const unidadeLogada = JSON.parse(localStorage.getItem('_immortal|' + UNIDADE_LOGADA_KEY));

    useEffect(() => {
      calculaProcedimentos();
      getConfig()
    }, [orcamentoProcedimentos]);

    useEffect(() => {
      alteraValorProcedimentoPorConvenio();
    }, [convenio]);

    const alteraValorProcedimentoPorConvenio = () => {
      const valoresProcedimentoPorConvenio = orcamentoProcedimentos.map(
        (item) => {
          const valorUnitario = id ? item?.valorUnitario :
            item.procedimento?.convenioProcedimentos?.find(
              (convenioProcedimento) =>
                convenioProcedimento?.convenio?.id === convenio?.value
            )?.valor || 0;
          return { ...item, valorUnitario };
        }
      );

      orcamentoStore.orcamento.orcamentoProcedimentos = valoresProcedimentoPorConvenio;
    }

    const getConfig = async () => {
      const configUnidade = await findConfiguracaoUnidade();
      setUtilizaFiltroPorConvenio(configUnidade?.utilizaFiltroDeProcedimentosPorConvenio)
    }

    const calculaProcedimentos = () => {
      const soma = orcamentoProcedimentos.reduce(
        (accumulator, currentValue) => {
          const valor =
            typeof currentValue?.valorUnitario === "string"
              ? string.currencyMaskToFloat(currentValue?.valorUnitario)
              : currentValue?.valorUnitario;
          return accumulator + valor;
        },
        0
      );
      orcamentoStore.orcamento.valor = soma;
    };

    const handleChangeValorProcedimento = (value, index) => {
      const selectedProcedimentos = [...orcamentoProcedimentos];
      selectedProcedimentos[index].valorUnitario = value;
      handleFieldModal("orcamentoProcedimentos", selectedProcedimentos);
    };

    const handleAddProcedimento = async (procedimento) => {
      if(!procedimento) return;

      let valorUnitario =
        procedimento?.convenioProcedimentos?.find(
          (convenioProcedimento) =>
            convenioProcedimento?.convenio?.id === convenio?.value
        )?.valor || 0;

      if (unidadeLogada?.rede?.whitelabel?.nome === 'DR_ATENDE'){
        const nomeConvenio = convenio?.descricao?.toLowerCase() || "";
        const  isParticularOrCisamusep = nomeConvenio?.includes('particular') || nomeConvenio?.includes('cisamusep');

        if(convenio?.value && !isParticularOrCisamusep) {
           try {
             const authResponse = await sujeitoAtencaoAutorizadoAgendarDetalhado({
               sujeitoId: sujeitoAtencaoSelected?.id,
               convenioId: convenio.value,
               procedimentos: [{ id: procedimento.id }]
             });
             if (authResponse.autorizado) {
               valorUnitario = 0;
             }
           } catch (error) {
             console.error('Error checking authorization:', error);
           }
        }
      }

      const selectedProcedimentos = [
        ...orcamentoProcedimentos,
        {
          procedimento,
          valorUnitario,
        },
      ];
      handleFieldModal("orcamentoProcedimentos", selectedProcedimentos);
    };

    const loadProcedimentos = async (search, loadedOptions, { page }) => {
      return handleLoadMoreProcedimentos({
        search,
        data: { page },
      });
    };

    const handleRemoveProcedimento = (procedimento, index) => {
      const selectedProcedimentos = [...orcamentoProcedimentos];
      selectedProcedimentos.splice(index, 1);
      handleFieldModal("orcamentoProcedimentos", selectedProcedimentos);
    };

    const handleLoadMoreProcedimentos = async ({ search, data }) => {
      let pageableDTO = {
        sortDir: "ASC",
        sortField: "nome",
        pageNumber: data.page,
        pageSize: 20,
      };

      const response = await findAllProcedimentos({
        nome: search,
        ativo: true,
        pageableDTO,
        ...(utilizaFiltroPorConvenio &&{convenioId: orcamento?.convenio?.value}),
        tiposProcedimentos: ["PROCEDIMENTO"],
      });

      const { content, last } = response;

      if (content) {
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: data.page + 1,
          },
        };
      }
    };

    const isOpenInfosOrcamento = orcamentoStore?.openInfosOrcamento
    return (
      <div className={classes.container}>
        <div className={classes.contentProcedimentos}>
          <label className={classes.title}>Procedimentos</label>
          <TextFieldSearch
            id="prt-pro-sel-prc"
            key={convenio?.value}
            classNotched={classes.notchedOutline}
            classInput={classes.inputTextField}
            classIcons={classes.classIcons}
            placeholder={"Selecione o procedimento"}
            onChange={(e, index) => handleAddProcedimento(e, index)}
            value={null}
            menuPlacement={"auto"}
            isClearable
            getOptionLabel={(option) => option.nome}
            getOptionValue={(option) => option.id}
            withPaginate
            loadOptions={loadProcedimentos}
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        </div>
        <Scroll classes={{ root: classNames(!isOpenInfosOrcamento? classes.tableMaior : classes.tableRoot )}}>
          <Table
            dados={orcamentoProcedimentos}
            columns={getColumns({
              handleChangeValorProcedimento,
              handleRemoveProcedimento,
            })}
            classes={{
              tabela: classNames(
                classes.table,
                tipoPagamento.value === "A_PRAZO" && classes.tableMenor
              ),
            }}
          />
        </Scroll>
        <div className={classes.containerTotal}>
          <div className={classes.contentTotal}>
            <label className={classes.total}> Subtotal: </label>
            <label className={classes.totalValue}>
              {applyCurrencyMask(orcamento.valor)}
            </label>
          </div>
          <div className={classes.contentTotal}>
            <label className={classes.total}> Total: </label>
            <label className={classes.totalValue}>
              {typeof orcamento.subtotal === "string"
                ? orcamento.subtotal
                : applyCurrencyMask(orcamento.subtotal)}
            </label>
          </div>
        </div>
      </div>
    );
  }
);

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    height: "100%",
    border: "1px solid rgba(0, 0, 0, 0.10)",
    borderRadius: "10px",
    justifyContent:"space-between",

    "& thead tr": {
      textAlign: "left",
      height: "32px",
    },
  },
  tableRoot: {
    height: "100%",
    maxHeight: "160px",
  },
  contentProcedimentos: {
    margin: "16px 16px 0",
  },
  notchedOutline: {
    border: "0",
  },
  contentTotal: {
    height: "40px",
    paddingRight: "8px",
    textAlign: "end",
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
    gap: "4px",
  },
  total: {
    fontWeight: 600,
    fontSize: 16,
  },
  totalValue: {
    fontWeight: 600,
    fontSize: 18,
  },
  table: {
    height: "100%",
    overflow: "auto",
  },
  tableMenor: {
    maxHeight: "100%",
  },
  containerTotal: {
    display: "flex",
    justifyContent: "space-between",
    paddingLeft: "10px",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  },
  tableMaior:{
    height:"100%",
    maxHeight:"315px"
  }
};

const ProcedimentosWithStyles = withStyles(styles)(Procedimentos);
export default inject("orcamentoStore")(ProcedimentosWithStyles);
